import React, {Component} from 'react';
import 'rc-tooltip/assets/bootstrap_white.css';

export default class TablaInmatriculacionCargaTitulo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: [],
            rowSelected: [],
            showFilter: false,
            showModeTarget: 'none',
            checkCodPlanEntrVehi: '',
            checkRowsPerdido: {},
        };
    }

    static pillFormatter(cell) {
        switch (cell) {
            case 'ERROR':
                return <span className='pill pill-block pill-red'>{cell}</span>;
            default:
                return ''
        }
    }

    functionDespliegue = (index) => {
        const isExpanded = index === this.state.rowSelected;
        return isExpanded;
    }

    toggleRow = (index) => {
        if (index === this.state.rowSelected) {
            this.setState({rowSelected: ''});
        } else {
            this.setState({rowSelected: index});
        }
    }

    activeTarget = (codigo, Rows) => {

        this.setState({
            showModeTarget: 'block',
            checkCodPlanEntrVehi: codigo,
            checkRowsPerdido: Rows,
        });

    }


    renderEstado(Rows) {
        if (Rows.error !== null) {
            return (
                <div className='dropdown kebab' role='group'>
                    <button className='btn dropdown-toggle kebab-btn pull-right'
                            name={'btnDropdownToggle'}><i
                        className='ion-android-more-vertical' name={'iconDropdownToggle'}/>
                    </button>
                    {
                        <ul className='dropdown-menu dropdown-menu-right'>
                            <li key={'DETALLE'}><a onClick={() => {

                                this.props.seleccionar(Rows);
                                this.props.openModal('ver-errores', this)
                            }}><i
                                className='ion-eye c-cyan'/><span>Ver Errores</span></a>
                            </li>
                        </ul>
                    }
                </div>);
        }else{
            return (
                <div className='dropdown kebab' role='group'>
                    <button className='btn dropdown-toggle kebab-btn pull-right'
                            name={'btnDropdownToggle'}><i
                        className='ion-android-more-vertical' name={'iconDropdownToggle'}/>
                    </button>
                    {
                        <ul className='dropdown-menu dropdown-menu-right'>
                            <li key={'PROCESAR'}><a
                                onClick={() => {
                                    this.props.onClickProcesarItem(Rows);
                                }}><i
                                className='ion-calendar c-cyan'/><span>Procesar</span></a>
                            </li>
                        </ul>
                    }
                </div>);

        }
    }

    render() {
        return (
            <section>
                <div className='tableWrapper'>
                    <div className='hidden-xs'>
                        <table className='table table-hover' style={{marginBottom: '140px'}}>
                            <thead className='table-head'>
                            <tr>
                                <th>
                                    <div className='checkbox checkbox-inline'>
                                        <label>
                                                <input type='checkbox' id={'checkBoxAll'} onClick={() => this.props.selectAll()} />
                                            <div className='checkbox-skin'/>
                                        </label>
                                    </div>
                                </th>
                                <th>NÚMERO</th>
                                <th>PROPIETARIO</th>
                                <th>SERIE</th>
                                <th/>
                                <th/>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.props.registros.map((Rows, i) => (


                                    <tr key={i}
                                    >
                                        <td>
                                            <div className='checkbox checkbox-inline'>
                                                <label>
                                                    <input type='checkbox'
                                                           checked={this.props.selectedID.indexOf(Rows.numPedidoVeh)>=0}/>
                                                    <div className='checkbox-skin'
                                                         onClick={() => this.props.handleOnClickProgramerAll(Rows.numPedidoVeh, Rows)}/>
                                                </label>
                                            </div>
                                        </td>
                                        <td>{Rows.numPedidoVeh}</td>
                                        <td>{Rows.desCliente}</td>
                                        <td>{Rows.numChasis}</td>
                                        <td>{TablaInmatriculacionCargaTitulo.pillFormatter(Rows.error != null ? 'ERROR' : '')}</td>
                                        <td>    {this.renderEstado(Rows)} </td>
                                    </tr>

                                ))

                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/tablasInmatriculacion/tblInmatriculacionCargaSituacion.js